module.exports = __webpack_public_path__ + "static/media/project3.d6447ab5.png";